import _ from "lodash";
import * as yup from "yup";
import allowedImageMimetypes from "helpers/allowedImageMimetypes";

export const Validation = {
  ALPHANUM: yup
    .string()
    .matches(/^[\w\-\s]*$/, "Please use only letters and numbers")
    .nullable(true),
  BOOLEAN: yup.boolean(),
  NUMBER: yup
    .number()
    .nullable(true)
    .transform((_, val) => (isNaN(val) ? val : null)),
  STRING: yup.string(),
  REQUIRED: yup.mixed().required(),
  EMAIL: yup.string().email("Please enter a valid email address"),
  NAME: yup.string().min(3, "Your name should be at least 3 characters long"),
};

const shouldIgnoreChecksForUrls = (input) => _.isString(input);

export function checkIfFilesAreTooBig(fileList) {
  if (!fileList?.length || shouldIgnoreChecksForUrls(fileList)) {
    return true;
  }
  const file = fileList[0];
  const sizeAsMb = file.size / 1024 / 1024;

  return sizeAsMb < 5;
}

export function checkIfFilesAreCorrectType(fileList) {
  if (!fileList?.length || shouldIgnoreChecksForUrls(fileList)) {
    return true;
  }
  const file = fileList[0];
  return allowedImageMimetypes.includes(file.type);
}

export const checkIfFileIsChosen = (fileList) => {
  if (shouldIgnoreChecksForUrls(fileList)) {
    return true;
  }
  if (!fileList?.length) {
    return false;
  }
  const file = fileList[0];
  return file && file.length;
};
